module.exports = __webpack_public_path__ + "static/media/img125.94ea8362.jpg";